module.exports = __webpack_public_path__ + "static/media/rca.220ef80e.png";